import React, { useState, useEffect } from "react";
import Header from "../headers/header";
import { Box, Typography, useTheme } from "@mui/material";
import { tokens } from "../../contexts/theme";
import FormatLineChart from "../../visualizations/FormatLineChart";
import { GetPastData } from "../../forge/main";
import { GetCurrentTime } from "../global/GetCurrentTime";
import convertToKST from "../global/convertToKST";
import DatePicker from "../global/DatePicker";

const WaterDetection = () => {
  const [data, setData] = useState([]);
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");

  const tunnel1 = 1097749;
  const tunnel2 = 1097762;

  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const primaryColor = colors.primary[400];
  const redAccentColor = colors.redAccent[300];
  const [bgColor, setBgColor] = useState(primaryColor);

  const title_str = "WATER DETECTION";
  const subtitle_str = [
    `물의 존재 여부를 탐지합니다 (1: true, 0: false). 총 2개 센서로부터 데이터를 받습니다.`,
  ];

  const DataChange = (lists) => {
    let ret = [];
    if (lists[0].length === 0 && lists[1].length === 0) return ret;

    let tunnel1_data = { id: "Tunnel1", color: "hsl(231, 70%, 50%)", data: [] };
    let tunnel2_data = { id: "Tunnel2", color: "hsl(139, 70%, 50%)", data: [] };

    let state = false;

    for(let i=0; i<2; i++){
      for(let j=0; j<lists[i].length; j++){
        if(!('DisplayData' in lists[i][j]) || !('MessageDate' in lists[i][j])) continue;

        const timestamp = parseInt(lists[i][j]["MessageDate"].match(/\d+/)[0], 10);
        const date = new Date(timestamp);

        let temp = 1;
        if(lists[i][j]["DisplayData"] === "No Water Present") temp = 0;

        if(i === 0) tunnel1_data.data.push({ x: date, y: temp });
        else tunnel2_data.data.push({ x: date, y: temp });

        if ("State" in lists[i][j] && lists[i][j]["State"] === 2) {
          state = true;
        }
      }
    }
    ret.push(tunnel1_data, tunnel2_data);
    return {data: ret, state};
  };

  useEffect(() => {
    const [Tfrom, Tto] = GetCurrentTime();
    const KSTfrom = convertToKST(Tfrom);
    const KSTto = convertToKST(Tto);
    setFrom(KSTfrom);
    setTo(KSTto);
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response1 = await GetPastData(tunnel1, from, to);
        const response2 = await GetPastData(tunnel2, from, to);

        // if (response1.Result.length === 0) {
        //   alert(`Tunnel-1에서 ${from} - ${to}에 측정된 데이터가 없습니다.`);
        // }
        // if (response2.Result.length === 0) {
        //   alert(`Tunnel-2에서 ${from} - ${to}에 측정된 데이터는 없습니다.`);
        // }
        const d = DataChange([response1.Result, response2.Result]);

        setData(d.data);
        setBgColor(d.state ? redAccentColor : primaryColor);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    if (from && to) {
      fetchData();
    }
  }, [from, to, primaryColor, redAccentColor]);

  return (
    <div>
      <Header title={title_str} subtitle={subtitle_str} />
      <Box>
        <DatePicker from={from} to={to} setFrom={setFrom} setTo={setTo} />
      </Box>
      <Box className="main-box" backgroundColor={bgColor}>
        <Box className="main-box-detail">
          <Box>
            <Typography variant="h3" fontWeight="600" color={colors.grey[100]}>
              물 여부 데이터
            </Typography>
          </Box>
        </Box>
        <Box className="main-box-graph">
          {data && (
            <FormatLineChart data={data} is_dashboard={false} y_label={"time"} />
          )}
        </Box>
      </Box>
    </div>
  );
};

export default WaterDetection;
